export const LOCALES = {
    ENGLISH: "en-US",
    PORTUGUESE: "pt-pt",
};